import { apiContact, apiSameOrigin } from 'services/api'

export const sendContact = async (payload) => {
  const { data } = await apiContact.post('501/feedback', payload)
  return data
}

export const sendBudget = async (payload) => {
  const { data } = await apiContact.post('573/feedback', payload)
  return data
}

export const sendOrder = async (payload) => {
  const { data } = await apiSameOrigin.post('/send-mail', payload)
  return data
}